import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  IWebhookProviderData,
  IWebhookProviderMethods
} from "@/models/providers/webhooks";

@Component
export default class WebhookInjectorMixin extends Vue {
  // Inject

  @Inject({ from: "webhookProviderData" })
  private readonly $webhookProviderData!: () => IWebhookProviderData;

  @Inject({ from: "webhookProviderMethods" })
  public readonly $webhookMethods!: IWebhookProviderMethods;

  // Computed

  public get $webhookData() {
    return this.$webhookProviderData();
  }
}
